var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.23 60.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #003851;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9637.09,
    y1: 11913.83,
    x2: -9637.09,
    y2: 11950.44,
    gradientTransform: "translate(-9600.01 11950.44) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aa4a2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5da5a2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#49a6a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3aa7a5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#31a8a5",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea9a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.39,16.15h0c-5.08-5.08-11.73-7.62-18.39-7.62s-13.31,2.54-18.39,7.62h0c-10.15,10.15-10.15,26.62,0,36.77h0c5.08,5.08,11.73,7.62,18.39,7.62s13.31-2.54,18.39-7.62h0c10.15-10.15,10.15-26.62,0-36.77Zm-2.04,34.73c-4.37,4.37-10.17,6.77-16.34,6.77s-11.98-2.4-16.34-6.77c-4.37-4.37-6.77-10.17-6.77-16.34s2.4-11.98,6.77-16.34c4.37-4.37,10.17-6.77,16.34-6.77s11.98,2.4,16.34,6.77c4.37,4.37,6.77,10.17,6.77,16.34s-2.4,11.98-6.77,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.2,24.12c-.45-.45-1.18-.45-1.63,0l-17.57,17.57-7.56-7.56c-.45-.45-1.18-.45-1.63,0l-.41.41c-.45.45-.45,1.18,0,1.63l8.38,8.38.2.2.2.2c.45.45,1.18.45,1.63,0l18.79-18.79c.45-.45.45-1.18,0-1.63l-.41-.41Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.47 0 66.23 .12 33.81 36.61 7.93 36.61 40.47 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.fe2984aac5e5ebc814c064e6ffa82487.svg";
export { ForwardRef as ReactComponent };